<template>
    <div id="head">
        <div id="shortcut-wrapper">
            <div id="shortcut">
                <ul class="fl">
                    <li>欢迎访问全国各省市区驻京办事处信息协会网站！</li>
                </ul>
                <ul class="fr" id="shortcut_r">
                    <!-- <li class="shortcut_btn">
                        <el-input
                            class="fullTextSearch"
                            placeholder="搜索"
                            v-model="fullTextSearchValue"
                            @keyup.enter.native="fullTextSearch()"
                        >
                            <i slot="prefix" class="el-input__icon el-icon-search" style="cursor:pointer;" @click="fullTextSearch()"></i>
                        </el-input>
                    </li> -->
                    <li>
                        <router-link to="/layout/join-us" class="joinUs">
                            <img src="@/assets/image/index/join_us.jpg" />
                            <span> 申请入会</span>
                        </router-link>
                    </li>
                    <li class="shortcut_btn" v-if="accountId === '' || accountId === null">
                        <router-link to="/layout/login" class="login" >
                            <img src="@/assets/image/index/login.png" />
                            <span>会员登录</span>
                        </router-link>
                    </li>
                    <li v-if="accountId !== '' && accountId !== null">
                        <a class="login" >
                            <el-dropdown trigger="click" @command="handleCommand">
                                <!-- <el-tooltip class="item" effect="dark" :content="loginName" placement="top-start">
                                    
                                </el-tooltip> -->
                                <span class="el-dropdown-link ellipsis_one loginName">
                                        <img src="@/assets/image/index/login.png" />
                                        <i>{{ loginName }}</i>
                                    </span>
                                <!-- <span class="el-dropdown-link">
                                    {{ loginName }}
                                </span> -->
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="personCenter">会员中心</el-dropdown-item>
                                    <el-dropdown-item command="exit">退出</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div id="logo-wrapper">
            <div id="logo">
                <div class="logo_lf fl">
                    <img src="@/assets/image/indexNew/logo_new.png" />
                </div>
                <div class="logo_title fl">
                    <h1>全国各省市区驻京办事处信息协会</h1>
                    <p>INFORMATION ASSOCIATION OF LOCAL GOVERNMENTS’BEIJING LIAISON OFFICES'</p>
                    <!-- <p>Information Association of Local Governments’Beijing Liaison Offices</p> -->
                    <!-- <p>QUAN GUO GE SHENG SHI QU ZHU JING BAN SHI CHU XIN XI XIE HUI</p> -->
                </div>
                <!-- <div class="logo-btm">
                    <router-link to="/layout/full-text-search" class="search">
                        <i class="el-icon-search"></i>
                        <span>搜索</span>
                    </router-link>
                    <router-link to="/layout/join-us" class="joinUs">
                        <img src="@/assets/image/index/join_us.jpg" />
                        <span> 申请入会</span>
                    </router-link>
                    <router-link to="/layout/login" class="login" v-if="accountId === '' || accountId === null">
                        <img src="@/assets/image/index/login.png" />
                        <span>会员登录</span>
                    </router-link>
                    <a class="login" v-if="accountId !== '' && accountId !== null">
                        <el-dropdown trigger="click" @command="handleCommand">
                            <span class="el-dropdown-link ellipsis_one loginName">
                                    <img src="@/assets/image/index/login.png" />
                                    <i>{{ loginName }}</i>
                                </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="personCenter">会员中心</el-dropdown-item>
                                <el-dropdown-item command="exit">退出</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </a>
                </div> -->
                    
            </div>
        </div>
        <div id="search-wrapper">
            <div id="search">
                <el-select v-model="modelType" placeholder="请选择" clearable style="border:1px solid #116EBA;">
                    <el-option
                        v-for="item in modelTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <el-input placeholder="请输入内容" v-model="fullTextSearchValue" @keyup.enter.native="fullTextSearch()" style="margin-left:10px;border:1px solid #116EBA;padding-right:0;">
                    <el-button slot="append" type="primary" class="search-btn" @click="fullTextSearch()">搜索</el-button>
                </el-input>
            </div>
        </div>
       
        <div id="nav-wrapper">
            <div id="nav">
                <div class="nav-lf"></div>    
                <div class="nav-mid">
                    <el-menu
                        :default-active="activeIndex"
                        class="el-menu-demo"
                        mode="horizontal"
                        @select="handleSelect"
                        background-color="#116EBA"
                        text-color="#fff"
                        active-text-color="#fff"
                        :router="true"
                    >
                        <el-menu-item index="1" route="/layout/index">首页</el-menu-item>
                        <el-menu-item index="2" route="/layout/association-introduction" >关于我们</el-menu-item>
                        <el-menu-item index="3" route="/layout/association-trends?type=2">动态要闻</el-menu-item>
                        <el-menu-item index="4" route="/layout/association-party?type=1">驻京党建</el-menu-item>
                        <el-submenu index="5">
                            <template slot="title">协会工作部</template>
                            <el-menu-item index="5-1" route="/layout/info-branch-introduction?id=1">信息工作部</el-menu-item>
                            <el-menu-item index="5-2" route="/layout/info-branch-introduction?id=2">双招双引工作部</el-menu-item>
                            <el-menu-item index="5-3" route="/layout/info-branch-introduction?id=3">医药卫生工作部</el-menu-item>
                            <el-menu-item index="5-4" route="/layout/info-branch-introduction?id=4">驻京企业工作部</el-menu-item>
                        </el-submenu>
                        <el-menu-item index="6" route="/layout/institution-list">会员风采</el-menu-item>
                        <!-- <el-submenu index="6">
                            <template slot="title">会员风采</template>
                            <el-menu-item index="6-1" route="/layout/institution-list">驻京办风采</el-menu-item>
                            <el-menu-item index="6-2" route="/layout/company-list">企业风采</el-menu-item>
                            <el-menu-item index="6-3" route="/layout/city-food">驻京美食</el-menu-item>
                            <el-menu-item index="6-4" route="/layout/good-product-list">名特优产品</el-menu-item>
                            <el-menu-item index="6-4" route="/layout/cultural-heritage-list">非物质文化遗产</el-menu-item>
                        </el-submenu> -->
                        <!-- <el-menu-item index="7" route="/layout/salon?id=1">品牌活动</el-menu-item> -->
                        <el-menu-item index="8" route="/layout/info-pool?id=4">信息交流</el-menu-item>
                        <el-menu-item index="" key="http://zjt.zjbinfo.com/home">
                            <a href="http://zjt.zjbinfo.com/home" target="_blank">驻京通</a>
                        </el-menu-item>
                        <el-menu-item index="10" route="/layout/city-food">驻京美食</el-menu-item>
                    </el-menu>
                </div>
                <div class="nav-rg"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCookie, setCookie} from '@/assets/utils/cookie.js'
export default {
    mixins: [],
    components: {},
    data() {
        return {
            activeIndex: '1',
            fullTextSearchValue: '',
            modelType: null,
            modelTypeList: [
                {
                    label: '动态要闻',
                    value: '1'
                },
                {
                    label: '驻京党建',
                    value: '2'
                },
                {
                    label: '共享信息',
                    value: '3'
                },
                {
                    label: '会员风采',
                    value: '4'
                },
                {
                    label: '驻京机构',
                    value: '5'
                },
                {
                    label: '驻京机构工作动态',
                    value: '6'
                },
                {
                    label: '会员企业工作动态',
                    value: '7'
                },
                {
                    label: '工作部活动',
                    value: '8'
                },
                {
                    label: '专家讲坛',
                    value: '9'
                },
                {
                    label: '医疗资源',
                    value: '10'
                },
                {
                    label: '医疗科普',
                    value: '11'
                },
                {
                    label: '项目展示',
                    value: '12'
                },
                {
                    label: '政策解读',
                    value: '13'
                },
                {
                    label: '会员企业风采',
                    value: '20'
                },
                {
                    label: '精彩瞬间',
                    value: '21'
                },
                {
                    label: '驻京美食',
                    value: '22'
                },
                {
                    label: '信息交流',
                    value: '23'
                }
            ],
        };
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
        loginName() {
            return this.$store.state.permission.loginName;
        }
    },
    created() {
        this.setActiveIndex();
        if (!this.accountId) {
            this.$store.dispatch('setLoginName', getCookie('loginName'));
            this.$store.dispatch('setAccountId', getCookie('accountId'));
            this.$store.dispatch('setCompanyId', getCookie('companyId'));
            this.$store.dispatch('setCompanyName', getCookie('companyName'));
            this.$store.dispatch('setAccountType', getCookie('accountType'));
        }
    },
    mounted() {
    },
    methods: {
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        },
        setActiveIndex() {
            console.log(this.$route.meta.parentIndex)
            if (this.$route.meta.parentIndex) {
                this.activeIndex = this.$route.meta.parentIndex;
            }
            else {
                this.activeIndex = null;
            }
        },
        handleCommand(command) {
            switch(command) {
                case 'personCenter': 
                    this.$router.push(
                        {
                            path: '/layout/update-member-info',
                        }
                    );
                    break;
                case 'exit':
                    setCookie('userName', '', 30);
                    setCookie('accountId', '', 30);
                    setCookie('acountType', '', 30);
                    setCookie('companyId', '', 30);
                    setCookie('companyName', '', 30);
                    setCookie('ticket', '', 30);
                    setCookie('loginName', '', 30);
                    this.$store.dispatch('setAccountId', '');
                    this.$router.push(
                        {
                            path: '/layout/login',
                            query: {
                                type: 'exit'
                            }
                        }
                    );
                    break;
            };
        },
        fullTextSearch() {
            this.$router.push(
                {
                    path: '/layout/full-text-search',
                    query: {
                        text: this.fullTextSearchValue,
                        type: this.modelType,
                    }
                }
            );
        }
    },
    watch: {
        // 监听路由对象中的变化
        '$route': {
            handler: function(to, from) {
                // 当路由发生变化时会调用这个函数
                // to 和 from 分别代表到达的路由和离开的路由
                this.setActiveIndex();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        }
    }
};
</script>

<style>
body {
    background: #f3f3f3;
}
#head {
    height:539px;
    background: url(../../assets/image/indexNew/header_bg.png) center / cover no-repeat;
}
#shortcut-wrapper {
    width: 100%;
    padding-top: 22px;
    margin-bottom: 50px;
}
#shortcut {
    width: 1280px;
    margin: 0 auto;
    overflow: hidden;
    
}
.fl {
    float: left;
}
#shortcut .fl li{
    color: #005091;
    font-size: 16px;
}
.fr {
    float: right;
}
#shortcut li {
    float: left;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    color: #262626;
    margin-right: 20px;
}
#shortcut li.spacer {
    overflow: hidden;
    margin: 11px 5px 0;
    width: 1px;
    height: 10px;
    background: #1d2129;
}
.shortcut_btn {
    position: relative;
    z-index: 21;
}
.shortcut_btn a {
    padding-left: 7px;
    padding-right: 7px;
    color: #1d2129;
    display: flex;
    justify-content: center;
}
#logo-wrapper,
#search-wrapper {
    width: 100%;
}
#logo {
    width: 1000px;
    height: 210px;
    margin: 0 auto;
    margin-bottom: 22px;
    overflow: hidden;
    position: relative;
}
.logo_lf img {
    display: block;
    width: 158px;
    height: 154px;
}
.logo_lf {
    /* padding-top: 35px; */
}
.logo_title {
    /* padding-top: 45px; */
    /* padding-left: 30px; */
}
.logo_title h1 {
    font-family: 思源黑体 CN;
    font-size: 50px;
    font-weight: 900;
    text-align: left;
    color: #C40B25;
    margin-bottom: 0;
    letter-spacing: 0.08em;
}
.logo_title p {
    font-family: 思源黑体 CN;
    font-size: 16px;
    font-weight: 489;
    line-height: 20px;
    text-align: left;
    color: #5A5A5A;
    font-family: 思源黑体 CN;
    letter-spacing: 0.135em;
}
.logo_rg {
    position:relative;
}
.logo_rg .bj {
    position: absolute;
    top: -2px;
    right: -50px; 
    display: block;
    width: 518px;
    height: 211px;
}
.login {
    /* top: 86px;
    right: 0px; */
}
.logo_rg .login img,
.logo_rg .joinUs img{
    width: 22px;
    height: 22px;
    margin-right: 5px;
}

.search i{
    color: #116EBA;
    padding-right: 5px;
}
.login,
.joinUs,
.search {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 30px;
    font-family: 思源黑体 CN;
    font-size: 14px;
    font-weight: 613;
    line-height: 30px;
    text-align: left;
    color: #262626;
    cursor:pointer;
}
.logo-btm .login:hover .loginName,
.logo-btm .joinUs:hover,
.logo-btm .search :hover{
    color: #116EBA;
}
#search {
    margin: 0 auto;
    width: 860px;
    margin-bottom: 115px;
    display: flex;
}
#search h3{
    font-family: 思源黑体 CN;
    font-size: 30px;
    line-height: 36px;
    letter-spacing: 0.04em;
    text-align: center;
    margin-bottom: 10px;
}
.search-btn{
    background: #116EBA !important;
    border: 1px solid #116EBA !important;
    color:#fff !important;
    border-radius: 0 !important;
}
#search .el-input-group__append {
    position: relative;
    padding-right:19px;
}
.search-btn:hover{
    border-color: #005091 !important;
    background-color: #005091 !important;
}
#nav-wrapper {
    position: relative;
}
#nav_lf {
    position: relative;
    left: 0;
    top: 0;
}
#nav_rg {
    position: relative;
}
#nav {
    width: 1374px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
#nav .el-submenu__title i {
    color: #fff;
    font-weight: bold;
}
#nav li{
    display: block;
    width: 142px;
    height: 48px;
    line-height: 48px;
    font-size: 17px;
    font-family: 思源黑体 CN;
    color: #fff;
    cursor: pointer;
    text-decoration: none;
    text-align: center;
}
#nav li:hover {
    background: #005091;
}
#nav li.is-active {
    background: #005091 !important;
}
#nav .el-menu-item {
  border-bottom: none !important; /* 移除下划线 */
}
.el-menu.el-menu--horizontal {
    border-bottom: none !important; /* 移除下划线 */
}
.el-menu--horizontal>.el-submenu .el-submenu__title{
    height: 48px  !important; 
    line-height: 48px  !important;
    font-size: 18px  !important;
    border-bottom: none !important; /* 移除下划线 */
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    background: #005091 !important;
}
.loginName{
    display: inline-block;
    /* width:140px; */
    font-family: 思源黑体 CN;
    font-size: 14px;
    font-weight: 613;
    line-height: 24px;
    text-align: left;
    color: #262626;
    cursor:pointer;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.loginName i {
    padding-left: 4px;
    font-style: normal;
}
.login span{
    padding-left: 4px;
}
.logo-btm{
    position: absolute;
    bottom: 6px;
    right:40px;
}
.fullTextSearch .el-input__inner{
    width: 120px;
    height: 24px;
    line-height: 24px;
    border-radius: 20px;
    background: #D9D9D9;
    color:#000;
    font-size: 14px;
;
}
.fullTextSearch .el-input__icon {
    height: 24px;
    line-height: 24px;
    color: #000;
}
.fullTextSearch .el-input__inner::placeholder {
  color: #000;
}
.nav-lf {
    width: 48px;
    height: 48px;
    background: #116EBA;
    clip-path: polygon(100% 0, 0 100%, 100% 100%);
}
.nav-rg {
    width: 48px;
    height: 48px;
    background: #116EBA;
    clip-path: polygon(0 0, 0 100%, 100% 100%);
}
.nav-mid {
    width: 1280px;
}
</style>